<template>
  <div class="cell">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'number-cell',
}
</script>
<style scoped>
.cell {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
